import "aos/dist/aos.css"
import parse from "html-react-parser"
import React, { memo } from "react"
import StarIcon from "../../../svg/new/star"
import * as style from "./footerClutch.module.css"

const FooterClutch = ({ footerClutchList }) => {
  return (
    <section className={style.counter}>
      <div className={`${style.counter_container}`}>
        <div className="row">
          <div className={style.counter_wrapper}>
            <ul className={style.counter_listing}>
              {footerClutchList?.map((item, index) => {
                return (
                  <li key={index}>
                    <div className={style.clutch_box}>
                      <div className={style.imageBox}>
                        <div> {parse(`${item?.footerClutchIcon}`)}</div>
                      </div>
                      <div>
                        <i>
                          <StarIcon />
                        </i>
                        <span>{item?.footerClutchRating}</span>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default memo(FooterClutch)
